const SUBSCRIPTIONS = {
  ALL: "ALL",
  FREE: "FREE",
  PAID: "PAID"
};

export default SUBSCRIPTIONS;